import { Component, OnInit, Input } from '@angular/core';
import { NotaCredito } from '../../../models/nota-credito';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ProductoService } from '../../../services/producto.service';
import { Compra } from '../../../models/compra';
import { CompraDetalle } from '../../../models/compra_detalle';

@Component({
  selector: 'app-notacredito-compra-modal',
  templateUrl: './notacredito-compra-modal.component.html',
  styleUrls: ['./notacredito-compra-modal.component.css'],
  providers: [NotaCreditoService, ProductoService]
})
export class NotacreditoCompraModalComponent implements OnInit {
  @Input() nota_credito_id: String;
  public nota: NotaCredito;
  public compra: Compra;
  public detalle: CompraDetalle;
  public loading = false;

  constructor(
      private notaService: NotaCreditoService,
      public bsModalRef: BsModalRef,
  ){
      this.nota = new NotaCredito();
      this.compra = new Compra();
      this.detalle = new CompraDetalle();
  }

  ngOnInit(){
      this.getNotaCreditoById();
  }

  getSubtotal(subtotal_iva12, subtotal_iva0){
    return parseFloat(subtotal_iva12) + parseFloat(subtotal_iva0);
  }

  getNotaCreditoById(){
      this.loading = true;
      let qs = '?embed=tipocomprobante,detalle?embed=producto,caja,estadobitacora,compra?embed=proveedor;bodega';
      this.notaService.getById(this.nota_credito_id, qs).subscribe(
          res => {
              this.loading = false;
              this.nota = res.data;
          },
          err => {
              this.loading = false;
          }
      );
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/nota-credito-compra-modal/notacredito-compra-modal.component.ts